module.exports = __webpack_public_path__ + "img/login_IMG_zx.f37c9d64.png";